module.exports = __webpack_public_path__ + "img/202311_01_sp.f8339145.jpg";